import { store } from '@checkout/store/store';
import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";

export default {
    name: 'CheckoutStep7p',

    mounted() {
        if (this.$route.query.hostedCheckoutId) {
            this.getPaymentStatus(this.$route.query.hostedCheckoutId);
        }        
    },

    methods: {
        getPaymentStatus(hostedCheckoutId) {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE');

            api.get(`/public-api/transaction-status?checkoutId=${hostedCheckoutId}`)
                .then((response) => {
                    if (response.data.status.validPayment) {
                        this.createOrder(true);
                    } else if (response.data.status.transactionStatusCode == 'CANCELLED_BY_CONSUMER') {
                        store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                        router.push('/checkout/'+localStorage.get("page-step", true))   
                    } else {
                        this.$swal({
                            title: this.$i18nApi.t('messages.error'),
                            icon: 'error',
                            buttons: {
                                confirm: {
                                    value: 0
                                }
                            }
                        }).then(() => {
                            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                        });
                    }
                })
                .catch(() => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    router.push('/checkout/4')
                })
        },

        createOrder() {
            store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
            
            api.post('/public-api/create-order', {billPayed: true})
                .then(() => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                    router.push('/checkout/7')
                })
                .catch(() => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                    this.$swal(this.$i18nApi.t('messages.error'));
                })
        },
    },
}
